import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import IconButton from "material-ui/IconButton";
import ShowChartIcon from "material-ui-icons/ShowChart";
import OvChartPanelContainer from "./OvChartPanelContainer";
import { humanRoughNumber } from "./helpers/presentation";
import dimensions from "react-dimensions";
import OvTimeBarMenu from "./OvTimeBarMenu";

import { purple } from "material-ui/colors";

import {
  XYPlot,
  XAxis,
  YAxis,
  HorizontalGridLines,
  VerticalBarSeries,
  Crosshair
} from "react-vis";
import { generateTimeSeries } from "./helpers/charts";

import { timeBarExpandRange, formatTimeCrosshairTitle } from "./helpers/charts";

const styles = theme => ({
  root: {
    padding: 10,
    marginBottom: 20
  },
  dimButton: { color: theme.palette.action.disabled },
  xaxis: {
    height: 60,
    borderWidth: 1,
    borderColor: "red",
    borderStyle: "solid"
  }
});

const generateSeries = (data, accumulate) => {
  const template = [
    {
      field: "cores",
      title: "Cores",
      color: purple[400]
    }
  ];
  return generateTimeSeries(template, data, accumulate);
};

class OvTimeCoresChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      crosshairValues: [],
      accumulate: false,
      stack: true,
      series: generateSeries(props.data, false),
      menuAnchor: null,
      menuOpen: false,
      menuPeriod: { start: null, end: null }
    };

    this.onAccumulateButtonClick = this.onAccumulateButtonClick.bind(this);
    this.handleNearestX = this.handleNearestX.bind(this);
    this.mouseLeaveHandler = this.mouseLeaveHandler.bind(this);
    this.formatCrosshairItems = this.formatCrosshairItems.bind(this);
    this.onBarClick = this.onBarClick.bind(this);
    this.handleRequestMenuClose = this.handleRequestMenuClose.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      series: generateSeries(nextProps.data, this.state.accumulate)
    });
  }

  renderCumulativeState() {
    return `${this.state.accumulate ? "Cumulative" : "Raw"}`;
  }

  onAccumulateButtonClick() {
    const newAccumulateState = !this.state.accumulate;
    this.setState({
      accumulate: newAccumulateState,
      series: generateSeries(this.props.data, newAccumulateState)
    });
  }

  renderSeries() {
    const { color, data } = this.state.series[0];
    return (
      <VerticalBarSeries
        onNearestX={this.handleNearestX}
        color={color}
        data={data}
        onValueClick={this.onBarClick}
      />
    );
  }

  handleNearestX(value, { index }) {
    const { series } = this.state;
    this.setState({
      crosshairValues: series.map(s => s.data[index])
    });
  }

  mouseLeaveHandler() {
    this.setState({ crosshairValues: [] });
  }

  formatCrosshairItems(values) {
    const { series } = this.state;
    return values.map((v, i) => {
      return {
        title: series[i].title,
        value: humanRoughNumber(v.y, 2)
      };
    });
  }

  onBarClick(datapoint, event) {
    this.setState({
      menuOpen: true,
      menuAnchor: event.event.currentTarget,
      menuPeriod: timeBarExpandRange(datapoint.x, this.props.granularity)
    });
  }

  handleRequestMenuClose() {
    this.setState({ menuOpen: false });
  }

  render() {
    const { containerWidth, classes } = this.props;
    const plotWidth = containerWidth - 60;
    return (
      <div>
        <OvChartPanelContainer
          chartTitle="Core hours"
          chartSubheader={this.renderCumulativeState()}
          chart={
            <div>
              <XYPlot
                onMouseLeave={this.mouseLeaveHandler}
                margin={{ left: 80, bottom: 50 }}
                className={classes.plot}
                width={plotWidth}
                height={200}
                xType="time-utc"
              >
                <HorizontalGridLines />
                {this.renderSeries()}
                <XAxis tickLabelAngle={-30} />
                <YAxis tickFormat={v => `${humanRoughNumber(v, 2)}`} />
                <Crosshair
                  itemsFormat={this.formatCrosshairItems}
                  titleFormat={formatTimeCrosshairTitle}
                  values={this.state.crosshairValues}
                />
              </XYPlot>
            </div>
          }
          chartActions={
            <div>
              <IconButton
                className={this.state.accumulate ? "" : classes.dimButton}
              >
                <ShowChartIcon onClick={this.onAccumulateButtonClick} />
              </IconButton>
            </div>
          }
        />

        <OvTimeBarMenu
          anchorEl={this.state.menuAnchor}
          open={this.state.menuOpen}
          filterState={this.props.filterState}
          onClose={this.handleRequestMenuClose}
          granularity={this.props.granularity}
          period={this.state.menuPeriod}
        />
      </div>
    );
  }
}

OvTimeCoresChart.propTypes = {
  data: PropTypes.array.isRequired,
  granularity: PropTypes.object.isRequired,
  containerWidth: PropTypes.number.isRequired
};

export { OvTimeCoresChart };

export default withStyles(styles, { name: "OvTimeCoresChart" })(
  dimensions({ elementResize: true })(OvTimeCoresChart)
);



// WEBPACK FOOTER //
// ./src/OvTimeCoresChart.js